window.EMB_PRODUCTS = {

pillow: {

"16x16": {
  white: 51504725754089,
  cream: 51504725786857,
  natural: 51504725819625,
  gray: 51504725852393,
  black: 51504725885161,
  navy: 51504725917929,
  sage: 51504725950697,
  dustyrose: 51504725983465
},

"18x18": {
  white: 51504726016233,
  cream: 51504726049001,
  natural: 51504726081769,
  gray: 51504726114537,
  black: 51504726147305,
  navy: 51504726180073,
  sage: 51504726212841,
  dustyrose: 51504726245609
},

"20x20": {
  white: 51504726278377,
  cream: 51504726311145,
  natural: 51504726343913,
  gray: 51504726376681,
  black: 51504726409449,
  navy: 51504726442217,
  sage: 51504726474985,
  dustyrose: 51504726507753
},

lumbar: {
  white: 51504726540521,
  cream: 51504726573289,
  natural: 51504726606057,
  gray: 51504726638825,
  black: 51504726671593,
  navy: 51504726704361,
  sage: 51504726737129,
  dustyrose: 51504726769897
}

}

};